"use client";

import styles from "@/styles/cart/settlement.module.scss";
import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { Button } from "react-vant";
import featuredSectionApi from "@/service/modules/featuredSectionApi";
import useCartActions from "@/utils/addTocartAction";
import { getCompressedImageUrl } from "@/utils/utils";
import { toast } from "@/components/global/Toast";

import { ProductType } from "@/types/product";
import { paymentInfoType, discountInfoType } from "@/types/cartProduct";

interface CartSettlementProps {
  selectNum: number;
  paymentInfo: paymentInfoType;
  discountInfo: discountInfoType;
  paymentLoading: boolean;
  isLogin: boolean;
  isUleeId: boolean;
  setPageDate?: (res: paymentInfoType) => void;
  checkoutEvent?: (callBack: () => void) => void;
  handleOpenPaypal?: () => void;
}

export default function CartSettlement({
  selectNum,
  paymentInfo,
  discountInfo,
  isLogin,
  isUleeId,
  setPageDate,
  checkoutEvent,
  handleOpenPaypal,
}: CartSettlementProps) {
  console.log(isUleeId);
  
  const [topSaleList, setTopSaleList] = useState<ProductType[]>([]);
  const getTopSaleList = async () => {
    try {
      const res = await featuredSectionApi.mooncakeBox("top-seller");
      const { data } = res;
      setTopSaleList(data.splice(0, 3));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTopSaleList();
  }, []);

  // 更新购物车列表
  const successAddCart = (res: paymentInfoType) => {
    if (setPageDate) {
      setPageDate(res);
    }
  };

  return (
    <div className={styles["comp-cart-settlement"]}>
      <div className={styles["settlement-title"]}>{`Total of ${
        selectNum || 0
      } Products`}</div>

      <div className={styles["amount-item"]}>
        <div className={styles["amount-title"]}>Sub Total:</div>
        <div className={styles["amount-value"]}>{`$ ${
          paymentInfo.subTotal || "0.00"
        }`}</div>
      </div>

      <div className={styles["amount-item"]}>
        <div className={styles["amount-title"]}>Shipping:</div>
        <div className={styles["amount-value"]}>{`$ ${
          (paymentInfo.shipping &&
            paymentInfo.shipping.toFixed(2).toString()) ||
          "0.00"
        }`}</div>
      </div>

      {/* Coupon Discount */}
      {typeof discountInfo?.couponDiscountValue === "number" &&
        !isNaN(discountInfo.couponDiscountValue) &&
        discountInfo.couponDiscountValue > 0 && (
          <div className={styles["amount-item"]}>
            <div className={styles["amount-title"]}>Coupon:</div>
            <div className={styles["amount-value"]}>
              - $ {discountInfo.couponDiscountValue.toFixed(2)}
            </div>
          </div>
        )}

      {/* Credits */}
      {typeof discountInfo?.credits === "number" &&
        !isNaN(discountInfo.credits) &&
        discountInfo.credits > 0 && (
          <div className={styles["amount-item"]}>
            <div className={styles["amount-title"]}>Credits:</div>
            <div className={styles["amount-value"]}>
              - $ {discountInfo.credits.toFixed(2)}
            </div>
          </div>
        )}

      {/* Points */}
      {typeof discountInfo?.pointsValue === "number" &&
        !isNaN(discountInfo.pointsValue) &&
        discountInfo.pointsValue > 0 && (
          <div className={styles["amount-item"]}>
            <div className={styles["amount-title"]}>CrazyPoints:</div>
            <div className={styles["amount-value"]}>
              - $ {discountInfo.pointsValue.toFixed(2)}
            </div>
          </div>
        )}

      <div className={styles["total-amount-item"]}>
        <div className={styles["total-amount-title"]}>Total Amount:</div>

        {typeof paymentInfo.total === "number" &&
          !isNaN(paymentInfo.total) &&
          paymentInfo.total > 0 && (
            <div
              className={styles["total-amount-value"]}
              style={{ color: "#D70B17" }}
            >
              {`$ ${paymentInfo.total.toFixed(2) || "0.00"}`}
            </div>
          )}
      </div>

      {/* 商品推荐 */}
      <div className={styles["top-sale-list"]}>
        {topSaleList.map((item) => (
          <TopSaleViewcarGoodsComponent
            key={item.productID}
            {...item}
            successAddCart={successAddCart}
          />
        ))}
      </div>

      <div className={styles["btn-box"]}>
        <Button
          round
          type="primary"
          style={{ fontWeight: 700 }}
          block
          disabled={!selectNum || paymentInfo.total <= 0}
          onClick={() =>
            checkoutEvent?.(() => {
              window.location.href = `/checkout${isLogin ? "" : "/express"}`;
            })
          }
        >
          Checkout
        </Button>

        <div className={styles["tips"]}>OR</div>

        <Image
          width={319}
          height={42}
          alt="paypal"
          src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-paypal.svg`}
          className={styles["express-pay-btn"]}
          onClick={handleOpenPaypal}
        />

        {!!(!isUleeId && (paymentInfo.total || 1) <= 3000) && (
          <>
            {!selectNum || paymentInfo.total <= 0 ? (
              <Image
                width={319}
                height={42}
                alt="afterpay"
                src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-after-pay.svg`}
                className={styles["express-pay-btn"]}
                style={{ marginTop: 14 }}
                onClick={() =>
                  checkoutEvent?.(() => {
                    console.log("afterpay click");
                  })
                }
              />
            ) : (
              <Image
                width={319}
                height={42}
                alt="afterpay"
                id="afterpayBtn"
                src={`${process.env.IMAGE_DOMAIN}/svg/view-cart/icon-after-pay.svg`}
                className={styles["express-pay-btn"]}
                style={{ marginTop: 14 }}
              />
            )}
          </>
        )}

        <Link href="/">
          <div className={styles["continue-shopping"]}>Continue Shopping</div>
        </Link>
      </div>
    </div>
  );
}

interface ProductProps {
  productID: string;
  filename: string;
  price: number | string;
  url: string;
  successAddCart: (res: paymentInfoType) => void;
}

const TopSaleViewcarGoodsComponent = ({
  productID,
  filename,
  price,
  url,
  successAddCart,
}: ProductProps) => {
  const { addToCart } = useCartActions();

  const [loading, setLoading] = useState(false);
  const addToCartCallBack = (response: paymentInfoType | "error") => {
    setLoading(false);
    if (response != "error") {
      successAddCart(response);
      toast.show("Add to cart successfully!");
    }
  };
  const addCart = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLoading(true);
    addToCart(event, { productID: productID, qty: 1 }, addToCartCallBack);
  };
  return (
    <div className={styles["goodsItem"]}>
      <Link href={url} legacyBehavior>
        <a rel="noopener noreferrer" className={styles["goods-image"]}>
          <Image
            width={94}
            height={94}
            alt={filename}
            src={getCompressedImageUrl(filename, 200)}
          />
        </a>
      </Link>
      <div className={styles["goods-price"]}>${price}</div>
      <Button
        round
        plain
        onClick={addCart}
        loading={loading}
        type="default"
        block
        size="mini"
        className={styles["goods-add-cart"]}
      >
        Add to Cart
      </Button>
    </div>
  );
};
